module.exports = __webpack_public_path__ + "img/冯智彪.5f77cfe3.jpg";